import React, { useState } from 'react';
import { useChangePassword } from '../../api/users';
import { useNotifications } from '../../context/NotificationContext';
import { X, Sun } from 'lucide-react';
import './LoginModal.css';

interface LoginModalNewPasswordProps {
  onClose: () => void;
}

const LoginModalNewPassword: React.FC<LoginModalNewPasswordProps> = ({ 
  onClose
}) => {
  const [password, setPassword] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const changePasswordMutation = useChangePassword();
  const { showSuccess, showError } = useNotifications();
  
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setErrorMessage('');
    
    if (password.trim()) {
      try {
        const result = await changePasswordMutation.mutateAsync({ 
          password: password
        });
        showSuccess('Password changed successfully');
        onClose();
      } catch (error: any) {
        showError('Password change failed', error);
      }
    }
  };

  return (
    <>
      <div className="modal-overlay" onClick={onClose}>
        <div className="modal-content" onClick={(e) => e.stopPropagation()}>
          <button 
            className="modal-close-btn" 
            onClick={onClose}
            aria-label="Close modal"
          >
            <X size={20} />
          </button>

          <h1 className="modal-title">Set a New Password!</h1>
          
          <p className="modal-description">
            Your account is successfully verified. Set a password to log in faster next time.
          </p>
          
          {errorMessage && (
            <div className="message message--error">
              {errorMessage}
            </div>
          )}
          
          <form onSubmit={handleSubmit} className="login-form">
            <div className="form-group">
              <label htmlFor="email">Password</label>
              <input
                type="password"
                id="password"
                className="form-input"
                value={password}
                onChange={(e) => {
                  setPassword(e.target.value);
                  if (errorMessage) setErrorMessage('');
                }}
                placeholder="Enter new password"
                required
                disabled={changePasswordMutation.isPending}
              />
            </div>
            
            <button 
              type="submit" 
              className="btn btn--primary btn--login"
              disabled={changePasswordMutation.isPending}
            >
              {changePasswordMutation.isPending ? 'Setting password...' : 'Set Password'}
            </button>
          </form>
        </div>
      </div>
    </>
  );
};

export default LoginModalNewPassword;
